import { memo } from 'react'

import { getStatusLabel } from './getStatusLabel'

export interface StatusLabelProps {
  name: string
}

export const StatusLabel = memo(({ name }: StatusLabelProps) => <span>{getStatusLabel(name)}</span>)
